export const formatFacilityCode = (facilityCode) => {
  if (facilityCode !== null) {
    let codeArray = [];

    // codeArray = facilityCode.split(",");
    let codes = facilityCode.map((code) => {
      if (code === null) code = "";
      if (code === "G01") code = "GENERATOR";
      if (code === "G02") code = "GENERATOR";
      if (code === "A01") code = "TRANSPORTER";
      if (code === "A02") code = "TRANSPORTER";
      if (code === "D00") code = "TSDF";
      if (code === "D00") code = "TSDF";
      if (code === "D00") code = "TSDF";
      if (code === "D79") code = "TSDF";
      if (code === "D80") code = "TSDF";
      if (code === "D81") code = "TSDF";
      if (code === "D82") code = "TSDF";
      if (code === "D83") code = "TSDF";
      if (code === "D99") code = "TSDF";
      if (code === "S01") code = "TSDF";
      if (code === "S02") code = "TSDF";
      if (code === "S03") code = "TSDF";
      if (code === "S04") code = "TSDF";
      if (code === "S05") code = "TSDF";
      if (code === "S99") code = "TSDF";
      if (code === "T01") code = "TSDF";
      if (code === "T02") code = "TSDF";
      if (code === "T03") code = "TSDF";
      if (code === "T31") code = "TSDF";
      if (code === "T47") code = "TSDF";
      if (code === "T76") code = "TSDF";
      if (code === "T99") code = "TSDF";
      // if(code === "H01") code = "Transfer Station";
      if (code === "H01") code = null;
      if (code === "M88") code = null;
      if (code === "M89") code = null;
      if (code === "R01") code = null;
      if (code === "RCA") code = null;

      return code;
    });

    let newCodeArray = Array.from(new Set(codes));
    newCodeArray = newCodeArray
      .filter((el) => {
        return el != null;
      })
      .sort((a, b) => {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });

    // let formattedCodes = newCodeArray.sort().join(", ");

    return newCodeArray;
  } else {
    return null;
  }
};

export const formatDate = (date) => {
  let newDate = new Date(date);
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(newDate);
  // add if need time
  //, hour: '2-digit', minute: '2-digit', second: '2-digit'
};

export const formatTransporterStatus = (status) => {
  let formattedStatus = "";

  //TODO: Change API to use CODE_REFERENCE_VALUE table instead
  if (status === "E") formattedStatus = "EXPIRED";
  if (status === "R") formattedStatus = "REVOKED";
  if (status === "A") formattedStatus = "ACTIVE";
  if (status === "D") formattedStatus = "DENIED";
  if (status === "V") formattedStatus = "VOLUNTARY";
  if (status === "S") formattedStatus = "SUSPENDED";

  return formattedStatus;
};
